/**
 * Metabase dashboard configuration.
 *
 * Dashboard IDs correspond to dashboards hosted on https://data.natives.it.
 */

export const METABASE_BASE_URL = 'https://data.natives.it/dashboard';

export const METABASE_DASHBOARD_IDS = {
  producer: '15-analisi-produttore',
  product: '17-analisi-prodotti',
  client: '31-analisi-cliente',
  agent: '32-analisi-agenti',
} as const;

export const getMetabaseUrl = {
  producer: (slug: string) =>
    `${METABASE_BASE_URL}/${METABASE_DASHBOARD_IDS.producer}?producer_slug=${encodeURIComponent(slug)}`,
  product: (rootSku: string) =>
    `${METABASE_BASE_URL}/${METABASE_DASHBOARD_IDS.product}?root_sku=${encodeURIComponent(rootSku)}`,
  client: (slug: string) =>
    `${METABASE_BASE_URL}/${METABASE_DASHBOARD_IDS.client}?client_slug=${encodeURIComponent(slug)}`,
  agent: (slug: string) =>
    `${METABASE_BASE_URL}/${METABASE_DASHBOARD_IDS.agent}?agente=${encodeURIComponent(slug)}`,
};
